var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllus6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55.5352,
    cy: 55.5351,
    r: 48.3518,
    transform: "rotate(81.5012 55.5352 55.5351)",
    stroke: "url(#paint0_linear_127_587)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.082 46.6211V68.6211",
    stroke: "#FF6C00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.082 50.6211H52.582C51.6538 50.6211 50.7635 50.9898 50.1072 51.6462C49.4508 52.3026 49.082 53.1928 49.082 54.1211C49.082 55.0494 49.4508 55.9396 50.1072 56.596C50.7635 57.2523 51.6538 57.6211 52.582 57.6211H57.582C58.5103 57.6211 59.4005 57.9898 60.0569 58.6462C60.7133 59.3026 61.082 60.1928 61.082 61.1211C61.082 62.0494 60.7133 62.9396 60.0569 63.596C59.4005 64.2523 58.5103 64.6211 57.582 64.6211H49.082",
    stroke: "#FF6C00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.082 26.6211V41.2878",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4154 29.2881H66.4154C65.7965 29.2881 65.203 29.5339 64.7654 29.9715C64.3279 30.409 64.082 31.0025 64.082 31.6213C64.082 32.2402 64.3279 32.8336 64.7654 33.2712C65.203 33.7088 65.7965 33.9546 66.4154 33.9546H69.7487C70.3675 33.9546 70.961 34.2004 71.3986 34.638C71.8362 35.0756 72.082 35.669 72.082 36.2878C72.082 36.9067 71.8362 37.5001 71.3986 37.9377C70.961 38.3753 70.3675 38.6211 69.7487 38.6211H64.082",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.082 69.6211V84.2878",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4154 72.2881H72.4154C71.7965 72.2881 71.203 72.5339 70.7654 72.9715C70.3279 73.409 70.082 74.0025 70.082 74.6213C70.082 75.2402 70.3279 75.8336 70.7654 76.2712C71.203 76.7088 71.7965 76.9546 72.4154 76.9546H75.7487C76.3675 76.9546 76.961 77.2004 77.3986 77.638C77.8362 78.0756 78.082 78.669 78.082 79.2878C78.082 79.9067 77.8362 80.5001 77.3986 80.9377C76.961 81.3753 76.3675 81.6211 75.7487 81.6211H70.082",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.082 54.6211V69.2878",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4154 57.2881H29.4154C28.7965 57.2881 28.203 57.5339 27.7654 57.9715C27.3279 58.409 27.082 59.0025 27.082 59.6213C27.082 60.2402 27.3279 60.8336 27.7654 61.2712C28.203 61.7088 28.7965 61.9546 29.4154 61.9546H32.7487C33.3675 61.9546 33.961 62.2004 34.3986 62.638C34.8362 63.0756 35.082 63.669 35.082 64.2878C35.082 64.9067 34.8362 65.5001 34.3986 65.9377C33.961 66.3753 33.3675 66.6211 32.7487 66.6211H27.082",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_127_587",
    x1: 104.387,
    y1: 104.387,
    x2: 31.4423,
    y2: 104.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6C00",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllus6);
export default __webpack_public_path__ + "static/media/illus6.66610ce791553f42d3fb0fd11e22b8b5.svg";
export { ForwardRef as ReactComponent };